import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import PaginatedListState from 'flarum/common/states/PaginatedListState';
import EventEmitter from 'flarum/common/utils/EventEmitter';
const globalEventEmitter = new EventEmitter();
export default class PollGroupListState extends PaginatedListState {
  constructor(params, page) {
    if (page === void 0) {
      page = 1;
    }
    super(params, page, 20);
    _defineProperty(this, "extraGroups", []);
    _defineProperty(this, "eventEmitter", void 0);
    this.eventEmitter = globalEventEmitter.on('pollgroup.deleted', this.deletePollGroup.bind(this));
  }
  get type() {
    return 'poll_groups';
  }
  requestParams() {
    var _this$params$sort;
    const params = {
      include: this.requestIncludes(),
      filter: this.params.filter || {},
      sort: this.sortMap()[(_this$params$sort = this.params.sort) != null ? _this$params$sort : '']
    };
    if (this.params.q) {
      params.filter.q = this.params.q;
    }
    return params;
  }
  includes() {
    return ['polls'];
  }
  requestIncludes() {
    const standard = this.includes();

    // merge the standard includes with the custom includes
    const merged = [...standard, ...(this.params.include || [])];

    // return as a comma separated string
    return merged.join(',');
  }
  loadPage(page) {
    if (page === void 0) {
      page = 1;
    }
    const preloadedGroups = app.preloadedApiDocument();
    if (preloadedGroups) {
      this.initialLoading = false;
      return Promise.resolve(preloadedGroups);
    }
    return super.loadPage(page);
  }
  clear() {
    super.clear();
    this.extraGroups = [];
  }

  /**
   * Get a map of sort keys (which appear in the URL, and are used for
   * translation) to the API sort value that they represent.
   */
  sortMap() {
    const map = {};
    if (this.params.q) {
      map.relevance = '';
    }
    map.newest = '-createdAt';
    map.oldest = 'createdAt';
    return map;
  }

  /**
   * In the last request, has the user searched for a poll group?
   */
  isSearchResults() {
    return !!this.params.q;
  }
  removePollGroup(pollGroup) {
    this.eventEmitter.emit('pollgroup.deleted', pollGroup);
  }
  deletePollGroup(pollGroup) {
    for (const page of this.pages) {
      const index = page.items.indexOf(pollGroup);
      if (index !== -1) {
        page.items.splice(index, 1);
        break;
      }
    }
    const index = this.extraGroups.indexOf(pollGroup);
    if (index !== -1) {
      this.extraGroups.splice(index, 1);
    }
    m.redraw();
  }

  /**
   * Add a poll group to the top of the list.
   */
  addPollGroup(pollGroup) {
    this.removePollGroup(pollGroup);
    this.extraGroups.unshift(pollGroup);
    m.redraw();
  }
  getAllItems() {
    return this.extraGroups.concat(super.getAllItems());
  }
  getPages() {
    const pages = super.getPages();
    if (this.extraGroups.length) {
      return [{
        number: -1,
        items: this.extraGroups
      }, ...pages];
    }
    return pages;
  }
}
flarum.reg.add('fof-polls', 'forum/states/PollGroupListState', PollGroupListState);